import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment'
import { ElementType, NumberFormat, SelectCombos, CommonResponses, } from '../Enums/constants';


export const PabsUkCallsTab = () => {
  return (
    <SurveyPage>
      <SurveyTitleArea labelText='' />
      <SurveyContentContainer>
        <SurveySection labelText='Volume'>
          <p>
            It is OK if you cannot answer all questions in this section. Answer as
            many as you can. If you have different telephone systems, processes or
            providers for actives, deferreds or pensioners then this tab can be
            duplicated for each - we suggest you contact us before proceeding.
          </p>
          <SurveyElement
            questionNumber='82'
            labelText='Number of incoming calls answered by a member of staff.'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            name='VolIncoming'
            allowUnknown
            placeholder='#, unknown'
          />
        </SurveySection>
        <SurveySection labelText='Access'>
          <SurveyElement
            questionNumber='83'
            labelText='Do you have a free-phone number (or a number where members are only charged the cost of a local call no matter where they are located)?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='q_146'
          />
          <SurveyElement
            questionNumber='84'
            labelText="How many hours per week is your 'call centre' operational? (If you do not have a call centre, how many hours a week is the administration team available to take calls)"
            inputType={ElementType.NUMBER}
            format={NumberFormat.DECIMAL1}
            placeholder='# hours'
            name='q_152'
          />
          <SurveyElement
            questionNumber='85'
            labelText='Do administrators provide their full name and contact number on covering letters when responding to specific requests from members (so the member can call and ask for them by name)?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='UKAdminContactInfo'
          />
        </SurveySection>
        <SurveySection labelText='Menu Layers'>
          <SurveyElement
            questionNumber='86'
            labelText="Do you have a menu layer?"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='MenuYN'
          />
          <SurveyConditionalSegment
            showIf={{
              MenuYN: {
                not: CommonResponses.NO.toLowerCase()
              }
            }}
          >
            <SurveyElement
              questionNumber='86.a'
              labelText="What is the average number of menu layers that must be navigated before a caller can speak to a live person? [Count each and every time a caller must select a menu option by pressing a button on the phone as a menu layer. Use the volume-weighted average number of menu layers if there are different menu-tree branches.]  Answer '0' if you do not have any menu layers."
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              name='Autoa'
            />
            <SurveyElement
              questionNumber='87'
              labelText='What is the average time in seconds that it would take a caller to listen to messages and navigate the menu before the caller is forwarded to a person (or to a queue for a person)?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              name='Autoc'
              allowNA
              allowUnknown
              placeholder='#, unknown, n/a'
            />
            <SurveyElement
              questionNumber='88'
              labelText='Is the menu system by-passed if a service representative is available?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO}
              name='MenuByPass'
            />
            <SurveyElement
              questionNumber='88.a'
              labelText='What percentage of calls is the menu system by-passed?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              allowUnknown
              placeholder='%, unknown'
              subQuestion
              showIf={{
                MenuByPass: {
                  not: CommonResponses.NO.toLowerCase()
                }
              }}
              name='MenuByPassPct'
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='Queuing'>
          <SurveyElement
            questionNumber='89'
            labelText='Do you have a queuing system?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='QueueServiceRep'
          />
          <SurveyConditionalSegment
            showIf={{
              QueueServiceRep: {
                not: CommonResponses.NO.toLowerCase()
              }
            }}
          >
            <SurveyElement
              questionNumber='89.a'
              labelText='What is the average wait time (in queue)?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder='# secs, unknown'
              subQuestion
              name='WaitQueueServiceRep'
              allowUnknown
            />
            <SurveyElement
              questionNumber='89.b'
              labelText='What % of calls were abandoned in queue?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              subQuestion
              name='HangupQueuePct'
              allowUnknown
              allowNA
              placeholder='%, unknown, n/a'
            />
            <SurveyElement
              questionNumber='90'
              labelText='Do you have an automated message that tells a queuing member his/her number or place in the queue or the estimated queue time?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO_NA}
              name='WaitTimeNotifyyn'
            />
            <SurveyElement
              questionNumber='91'
              labelText='Are member in queue given an automated call-back option (e.g., “we will keep your place in the queue and call you back as soon as one of our operators is available”)?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.YES_NO_NA}
              name='CallbackFeature'
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='Contact Centre Operators versus Pension Administrators'>
          <SurveyElement
            questionNumber='92'
            labelText="Is a contact centre operator the first point of human contact when a member calls? (A 'contact centre operator' is someone who might handle only basic requests, i.e., not a pensions administrator.)"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='ReceptionistFirstContact'
          />
        </SurveySection>
        <SurveySection labelText='Post-Connection'>
          <SurveyElement
            questionNumber='93'
            labelText='Do you monitor what happens to telephone calls after they connect? (e.g., number of times members are transferred, first contact satisfaction)'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='UKDoYouTrackCalls'
          />
          <SurveyConditionalSegment
            showIf={{
              UKDoYouTrackCalls: { not: CommonResponses.NO.toLowerCase() },
            }}
          >
            <SurveyElement
              questionNumber='93.a'
              labelText=' What % of calls were resolved by the first contact?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.PERCENTAGE_UK}
              allowUnknown
              placeholder='%, unknown'
              subQuestion
              name='q_150a'
            />
            <SurveyConditionalSegment
              showIf={{
                q_150a: [CommonResponses.NOT_UNKNOWN]
              }}
            >
              <SurveyElement
                questionNumber='93.b'
                labelText="In your definition of 'first contact resolution':"
                subQuestion
                name='FirstContactCallTransferredDefinition'
              />
              <SurveyElement
                questionNumber='93.b.b1'
                labelText='Do you include calls that were transferred?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                doubleSubQuestion
                name='FirstContactCallTransferred'
              />
              <SurveyElement
                questionNumber='93.b.b2'
                labelText='Do you include calls where the member needs a call back?'
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                doubleSubQuestion
                name='FirstContactCallBack'
              />
              <SurveyElement
                questionNumber='93.b.b3'
                labelText="Do you include calls that might create a new task in the 'back-office'?"
                inputType={ElementType.RADIOBUTTON}
                options={SelectCombos.YES_NO}
                doubleSubQuestion
                name='FirstContactCallNewTask'
              />
            </SurveyConditionalSegment>
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='Sharing Information During a Call'>
          <SurveyElement
            questionNumber='94'
            labelText='When a member calls in, does the person taking the call have immediate computer access to the following:'
          />
          <SurveyElement
            questionNumber='94.a'
            labelText="Record of the member's previous calls?"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='q_155a'
          />
          <SurveyElement
            questionNumber='94.b'
            labelText='Copies of recent correspondence on-line?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='q_155b'
          />
          <SurveyElement
            questionNumber='94.c'
            labelText='A knowledge-sharing help system for use by the administrator?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='q_155c'
          />
          <SurveyElement
            questionNumber='94.d'
            labelText='Most recent member statement (or the data from the statement)?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='CapabilityMemberStatement'
          />
          <SurveyElement
            questionNumber='94.e'
            labelText='Transfer value?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO_NA}
            subQuestion
            name='q_155d'
          />
          <SurveyElement
            questionNumber='94.f'
            labelText='DC / AVC account balance?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO_NA}
            subQuestion
            name='UKCallsDCAccountBal'
          />
          <SurveyElement
            questionNumber='94.g'
            labelText='Pensionable salary?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='q_155e'
          />
          <SurveyElement
            questionNumber='94.h'
            labelText='Salary history?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='q_155f'
          />
          <SurveyElement
            questionNumber='94.i'
            labelText='Pensionable service?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='q_155g'
          />
          <SurveyElement
            questionNumber='94.j'
            labelText='Pensionable service history?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='q_155h'
          />
          <SurveyElement
            questionNumber='94.k'
            labelText='The ability to generate a pension estimate - and talk about the numbers with the member whilst on the phone?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='q_156a'
          />
          <SurveyElement
            questionNumber='94.l'
            labelText='Home address?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='q_155j'
          />
          <SurveyElement
            questionNumber='94.m'
            labelText='Amounts payable on death?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='UKLifeAssuranceyn'
          />
          <SurveyElement
            questionNumber='94.n'
            labelText='Real-time access to a workflow system (to understand the status of open items)?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            subQuestion
            name='WorkflowSystem'
          />
          <SurveyElement
            questionNumber='95'
            labelText='Do you have security routines that allow staff members to discuss member specific information on the phone?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='UKCallsSecurityRoutines'
          />
          <SurveyElement
            questionNumber='96'
            labelText='Can staff screen share with members?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='CoBrowsing'
          />
        </SurveySection>



        <SurveySection labelText='Change of Address'>
          <SurveyElement
            questionNumber='97'
            labelText='Can members notify you of a change of address over the telephone? (i.e., without writing in)'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='SACRSChangeAddress'
          />
        </SurveySection>

        <SurveySection labelText='Quality Monitoring'>
          <SurveyElement
            questionNumber='98'
            labelText="Do you review your staff's responses to member calls for coaching purposes on a regular basis? [As opposed to intermittent, or only while training new service representatives, etc.]"
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='q_158'
          />
          <SurveyConditionalSegment
            showIf={{
              q_158: {
                not: CommonResponses.NO.toLowerCase()
              }
            }}
          >
            <SurveyElement
              questionNumber='98.a'
              labelText='How many calls per staff member per month on average do you monitor?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              subQuestion
              name='CoachingCallsMonthlyFreq'
            />
            <SurveyElement
              questionNumber='98.b'
              labelText='Are you listening in on a live call or a recording?'
              note="If you are doing both, respond 'Recording'. The result of listening to either both or solely a recording is similar for the purposes of this survey."
              inputType={ElementType.RADIOBUTTON}
              options={['Live', 'Recording']}
              subQuestion
              name='MonitoringCalls'
            />
          </SurveyConditionalSegment>
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  )
}